import type { FC, ProviderProps, SetStateAction } from 'react';

import { createContext, useContext } from 'react';

import type { AlgoliaProductHit, ProductHit } from '~/types/algolia';

export interface TileContextProps {
  singleProduct: AlgoliaProductHit;
  filteredVariants: ProductHit[];
  tileHovered?: boolean;
  setVariantHovered: (variantHovered: SetStateAction<number>) => void;
}

const TileBaseContext = createContext<TileContextProps | undefined>(undefined);

export const useTileBaseContext = () => {
  const context = useContext(TileBaseContext);

  if (context === undefined) {
    throw new Error('`useTileBaseContext` is used outside the `<TileBaseProvider />');
  }

  return context;
};

export const TileBaseProvider: FC<ProviderProps<TileContextProps>> = ({ children, value }) => (
  <TileBaseContext.Provider value={value}>{children}</TileBaseContext.Provider>
);
